export default class RestError {
	constructor(code, message) {
		this.code = code;
		this.message = message;
	}
}
